import React, {useContext} from "react";
import {useDispatch} from "react-redux";
import {DutyManagerReportEditableContext} from "../../../Context/DutyManagerReportEditable";
import {EndOfShiftReportPayload} from "../../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActionTypes";
import {newMedicationAdministered} from "../../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActions";
import MedicationAdministeredItem from "./MedicationAdministeredItem";
import {FaPlus} from "react-icons/fa";

const MedicationAdministeredSection = (props: EndOfShiftReportPayload) => {
    const editable = useContext(DutyManagerReportEditableContext);
    const dispatch = useDispatch();

    const addNewMedication = () => {
        dispatch(newMedicationAdministered());
    };

    return (
        <>
            <div className="eos-section">
                <div className="eos-drug-section">
                    <h2 className="eos-title">
                        Medication Administered
                        <button className="add-btn" disabled={!editable} onClick={addNewMedication}>
                            <FaPlus /> Add Administration
                        </button>
                    </h2>

                    <div className="eos-drug-grid">
                        <div className="eos-drug-grid-heading">Pack</div>
                        <div className="eos-drug-grid-heading">Drug</div>
                        <div className="eos-drug-grid-heading">Administered By</div>
                        <div className="eos-drug-grid-heading"></div>
                        {props.medicineAdministered?.map((item) => (
                            <MedicationAdministeredItem administration={item} key={item.uid} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MedicationAdministeredSection;
